var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{ref:"cascader",attrs:{"options":_vm.animal,"load-data":_vm.loadAnimalData,"value":_vm.val,"change-on-select":"","placeholder":_vm.placeholder},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }